<template>
    <div class="product-avatar">
        <div class="avatar-gray avatar-plr26">
            <div class="avatar-img-wrap">
                <img :src="step_img1" width="100%" />
            </div>
            <div class="avatar-title" style="margin-top: 22px;">
                合同智审，全AI自动驱动
            </div>
            <div class="avatar-title">
                定义合同审查新范式
            </div>
            <div class="avatar-txt" style="margin-top: 18px;padding: 0 15px 40px;">从上传到定稿，审查全流程由AI自主决策、智能驱动，告别手忙脚乱 ，迎来一键智能。</div>
        </div>
        <div class="avatar-plr40 avatar-over">
            <div class="avatar-second-title avatar-pt60">
                智能解析与动态清单
            </div>
            <div class="avatar-desc avatar-pt17">AI自动解析合同，一键生成审查清单，并支持实时调整审查维度；审查后可持续优化清单，一键重新审查，标准越用越精。</div>
            <img class="avatar-img2" :src="step_img2" alt="">
        </div>
        <div class="avatar-gray avatar-plr40 avatar-over">
            <div class="avatar-second-title avatar-pt60">
                精准风险审查与立场适配
            </div>
            <div class="avatar-desc avatar-pt17">支持甲方、乙方、中性立场一键切换，AI自动适配审查策略；并自动完成风险定位、解析、评级，同步输出修改建议，实现精准打击。</div>
            <img class="avatar-img3" :src="step_img3" alt="">
        </div>
        <div class="avatar-plr40 avatar-over">
            <div class="avatar-second-title avatar-pt60">
                主动防御与双向溯源
            </div>
            <div class="avatar-desc avatar-pt17">基于场景自动预警缺失条款，提示补充建议，构建主动防御；支持风险点与原文双向定位，实现审查过程无缝溯源与验证。</div>
            <img class="avatar-img4" :src="step_img4" alt="">
        </div>
        <div class="avatar-plr40 avatar-over">
            <div class="avatar-second-title avatar-pt60">
                审查成果输出
            </div>
            <div class="avatar-desc avatar-pt17">支持一键导出带详细批注的审查报告，也可直接生成带痕迹的修订版合同，确保审查成果可存档、可交付、可立即投入实际使用。</div>
            <img class="avatar-img4" :src="step_img5" alt="">
        </div>

        <div>
            <nowdownload />
        </div>
        <Footer />
    </div>
</template>

<script>
import nowdownload from '@/components/nowdownload/index'
import { Footer} from '@/components'

function requireImg(str) {
    return require("pbimages/contract/" + str);
}
export default {
    components:{
        nowdownload,
        Footer,
    },
    data() {
        return {
            step_img1: requireImg("step1.png"),
            step_img2: requireImg("step2.png"),
            step_img3: requireImg("step3.png"),
            step_img4: requireImg("step4.png"),
            step_img5: requireImg("step5.png"),
        };
    },
    created() {},
    methods: {},
};
</script>

<style lang="stylus" scoped>
.avatar-plr26{
    padding: 0 26px;
}
.avatar-plr40{
    padding: 0 40px;
}
.avatar-pt60{
    padding-top: 60px;
}
.avatar-pt17{
    padding-top: 17px;
}
.avatar-over{
    overflow: hidden;
}
.product-avatar{
    min-height: 100vh;
    background: #fff;
    overflow: hidden;
}
.avatar-gray{
    background: #f8f9fb;
}
.avatar-img-wrap{
    width: 608px;
    margin: 0 auto 0;
    padding-top: 70px;
}
.avatar-title{
    color: #303443;
    font-size: 38px;
    font-weight: bold;
    line-height: 54px;
    width: 420px;
    margin: 0 auto;
}
.avatar-txt{
    color: #5E606B;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
}
.avatar-second-title{
    color: #303443;
    font-size: 33px;
    font-weight: 600;
}
.avatar-desc{
    color: #000000;
    font-weight: 400;
    font-size: 20px;
    line-height: 31px;
}
.avatar-img2{
    width: 645px;
    display: block;
    margin: 26px auto 60px;
}
.avatar-img3{
    width: 624px;
    display: block;
    margin: 38px auto 84px;
}
.avatar-img3{
    width: 624px;
    display: block;
    margin: 38px auto 84px;
}
.avatar-img4{
    width: 611px;
    display: block;
    margin: 21px auto 60px;
}
</style>
